/**
 * Stop im KI-Chat: POST /api/ai/chat/cancel bricht den laufenden Turn auf dem
 * Server ab (Modell-Stream, Zwischenstand speichern, Sperre freigeben). Vorher
 * beendete der Stop-Knopf nur die Anzeige; der Turn lief bis zu 15 Minuten
 * weiter und die nächste Nachricht bekam „Chat ist beschäftigt“.
 */
export type ChatCancelResult = {
  /** Der Server hat den Turn abgebrochen (oder er lief schon nicht mehr dort). */
  cancelled: boolean;
  /** Zwischenstand gespeichert und Sperre frei – der Verlauf kann sofort geladen werden. */
  settled: boolean;
  status: string;
};

/** Hinweis unter einer Antwort, die per Stop beendet wurde. */
export const ABORTED_TURN_HINT = 'Antwort abgebrochen.';

export function parseChatCancelResponse(data: unknown): ChatCancelResult {
  const rec = data && typeof data === 'object' ? (data as Record<string, unknown>) : {};
  const status = typeof rec.status === 'string' ? rec.status : 'unknown';
  return {
    cancelled: rec.cancelled === true,
    settled: rec.settled === true,
    status,
  };
}

export async function requestChatCancel(
  params: { chatId: string | null; requestId: string | null },
  fetchImpl: typeof fetch = fetch,
): Promise<ChatCancelResult> {
  const res = await fetchImpl('/api/ai/chat/cancel', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ chatId: params.chatId, requestId: params.requestId }),
  });
  if (!res.ok) {
    return { cancelled: false, settled: false, status: `http_${res.status}` };
  }
  const data = await res.json().catch(() => null);
  return parseChatCancelResponse(data);
}
